import WeightDisc from './WeightDisc';
import HeavyProgressBar from './HeavyProgressBar';

/**
 * BrandSplash — pantalla de carga de la identidad v2.1 (manual: wordmark, disco
 * y Heavy bar sobre placa de concreto con un atleta muy tenue al fondo).
 *
 * message — texto principal. detail — línea secundaria. progress — 0..100 o
 * null (indeterminado: la barra respira al 40 %). children — acciones de
 * escape u otros elementos bajo la barra.
 */
const BrandSplash = ({ message = 'Preparando tu plan', detail = 'Un momento…', progress = null, children }) => (
  <div className="relative min-h-screen bg-zinc-950 overflow-hidden flex flex-col items-center justify-center gap-6 px-4 py-16 tx" data-testid="brand-splash">
    <div
      aria-hidden="true"
      className="absolute inset-[-6%_0] bg-cover bg-[center_30%] opacity-20 onor-kb pointer-events-none"
      style={{ backgroundImage: "url('https://images.unsplash.com/photo-1574680096145-d05b474e2155?auto=format&fit=crop&w=1400&q=70')", mixBlendMode: 'luminosity' }}
    />
    <div aria-hidden="true" className="absolute inset-0 pointer-events-none" style={{ background: 'linear-gradient(180deg,#0B0C0E 0%,rgba(11,12,14,.55) 35%,rgba(11,12,14,.75) 70%,#0B0C0E 100%)' }} />
    <div aria-hidden="true" className="plate-bg" />
    <div className="relative z-10 onor-rise" style={{ animationDelay: '.15s' }}>
      <div className="relative px-6 py-4 onor-breathe">
        <img src="/brand/wordmark-3d-tight.webp" alt="ONOR CODE" width="340" height="180" draggable="false" className="w-[min(340px,80vw)] h-auto" />
        <i className="onor-glint" aria-hidden="true" />
        <i className="corner corner-tl" aria-hidden="true" />
        <i className="corner corner-br" aria-hidden="true" />
      </div>
    </div>
    <div className="relative z-10 w-full max-w-sm flex flex-col gap-6">
      <div className="flex items-center justify-center gap-4">
        <WeightDisc size={56} label="" />
        <div className="text-left">
          <p className="font-display font-bold uppercase text-2xl leading-8 text-zinc-100" aria-live="polite">{message}</p>
          <p className="text-sm text-zinc-400">{detail}</p>
        </div>
      </div>
      <HeavyProgressBar value={progress ?? 40} label="Heavy Progress" right={progress != null ? `[${Math.round(progress)} %]` : null} />
      <div className="flex justify-center gap-3 font-display font-semibold uppercase tracking-[.24em] text-xs text-zinc-400">
        <span className="onor-rise" style={{ animationDelay: '.6s' }}>Honor</span>
        <span className="onor-rise" style={{ animationDelay: '.9s' }}>Disciplina</span>
        <span className="onor-rise text-bronze" style={{ animationDelay: '1.2s' }}>Fuerza</span>
      </div>
      {children}
    </div>
    <p aria-hidden="true" className="absolute left-4 right-4 bottom-6 flex justify-between font-display text-xs tracking-[.14em] uppercase text-zinc-400/80">
      <span>45 LBS · 20.4 KG</span><span>MEX · Est. 2025</span>
    </p>
  </div>
);

export default BrandSplash;
